import React from 'react';
import "./onboard-orline-style.scss";
import {useTranslation} from "react-i18next";

const OnboardOrLine = () => {

    const {t} = useTranslation();

    return (
        <div className="onboard-orline-root">
            <div className="onboard-orline-line"></div>
            <div className="onboard-orline-text">{t('home.or_line')}</div>
            <div className="onboard-orline-line"></div>
        </div>
    )
};

export default OnboardOrLine;
